export enum ManagementManagedServicesGetters {
    GET_FORM_VALUES = 'GET_FORM_VALUES',
}
